import styled from 'styled-components';

const ItemStyles = styled.article`
  border-bottom: 1px solid ${(props) => props.theme.offWhite};
  padding: 20px 12px 30px;
`;

export default ItemStyles;
